"use client"
import { ArrowLeft } from 'lucide-react';
import { useRouter } from 'next/navigation';
import { FormattedMessage } from '@/components/elements';
import style from '@/assets/styling/scss/goback.module.scss';

export default function GoBack() {
  const router = useRouter();

  const handleGoBack = () => {
    if (window.history.length > 1) {
      router.back();
    } else {
      router.push('/');
    }
  };

  return (
    <div className={style.goBack} onClick={handleGoBack}>
      <ArrowLeft />
      <FormattedMessage id="go_back" />
    </div>
  );
}
